(function (app) {

	window.btoa = window.btoa || $.base64.encode;
	window.atob = window.atob || $.base64.decode;

	app.guidToBase64 = function (string) {
		if (!string) return '';

		var bytes = [];
		var g = string.replace(/-/g, '');

		bytes[0] = parseInt(g.substr(3 * 2, 2), 16);
		bytes[1] = parseInt(g.substr(2 * 2, 2), 16);
		bytes[2] = parseInt(g.substr(2, 2), 16);
		bytes[3] = parseInt(g.substr(0, 2), 16);

		bytes[4] = parseInt(g.substr(5 * 2, 2), 16);
		bytes[5] = parseInt(g.substr(4 * 2, 2), 16);

		bytes[6] = parseInt(g.substr(7 * 2, 2), 16);
		bytes[7] = parseInt(g.substr(6 * 2, 2), 16);

		var i = 16;
		while (i < g.length - 1) {
			bytes[i / 2] = parseInt(g.substr(i, 2), 16);
			i += 2;
		}
		var chars = String.fromCharCode.apply(null, bytes);
		return window.btoa(chars).replace(/\//g, '-').replace(/\+/g, '_').substr(0, 22);
	};

	app.guidFromBase64 = function (string) {

		if (!string || string === app.guidHashedEmpty) return '';

		try {

			var chars = window.atob(string.replace(/-/g, '/').replace(/_/g, '+') + '==').split('');
			var bytes = [];
			var i;
			for (i = 0; i < chars.length; i++) {
				bytes[i] = chars[i].charCodeAt(0);
			}
			var addLeadingZero = function (number) {
				if (number.toString().length === 2) {
					return number;
				} else {
					return '0' + number;
				}
			};

			var result = '';
			result += addLeadingZero(bytes[3].toString(16));
			result += addLeadingZero(bytes[2].toString(16));
			result += addLeadingZero(bytes[1].toString(16));
			result += addLeadingZero(bytes[0].toString(16));
			result += '-';
			result += addLeadingZero(bytes[5].toString(16));
			result += addLeadingZero(bytes[4].toString(16));
			result += '-';
			result += addLeadingZero(bytes[7].toString(16));
			result += addLeadingZero(bytes[6].toString(16));
			result += '-';
			result += addLeadingZero(bytes[8].toString(16));
			result += addLeadingZero(bytes[9].toString(16));
			result += '-';

			for (i = 10; i < chars.length; i++) {
				result += addLeadingZero(bytes[i].toString(16));
			}

			if (result === app.guidEmpty || !result.isGuid()) result = '';

		} catch (e) {
			result = '';
		}

		return result;
	};
})(app);